// src/pages/ContentEditor/components/EditorHeader.js
import React from 'react';
import { Box, Typography, Button, IconButton, CircularProgress } from '@mui/material';
import { 
  ArrowBack as ArrowBackIcon,
  Save as SaveIcon,
  Cancel as CancelIcon
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

const EditorHeader = ({ 
  isNewContent, 
  contentTitle, 
  saving, 
  unsavedChanges, 
  onCancel, 
  onSave 
}) => {
  const theme = useTheme();
  
  return (
    <Box sx={{ mb: 4, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2 }}>
      <IconButton
        onClick={onCancel}
        sx={{ mr: 1, color: theme.palette.text.primary }}
        aria-label="back"
      >
        <ArrowBackIcon />
      </IconButton>
      
      <Typography variant="h4" component="h1" color="primary" fontWeight="bold" sx={{ flexGrow: 1 }}>
        {isNewContent ? 'Create New Reading Practice' : `Edit: ${contentTitle || ''}`}
      </Typography>
      
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          variant="outlined"
          sx={{ color: theme.palette.text.primary, borderColor: theme.palette.text.secondary }}
          startIcon={<CancelIcon />}
          onClick={onCancel}
        >
          Cancel
        </Button>
        
        <Button
          variant="contained"
          color="primary"
          startIcon={saving ? <CircularProgress size={24} color="inherit" /> : <SaveIcon />}
          onClick={onSave}
          disabled={saving || (!isNewContent && !unsavedChanges)}
        >
          {saving ? 'Saving...' : 'Save'}
        </Button>
      </Box>
    </Box>
  );
};

export default EditorHeader;